import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getOtpRequest, verifyOtpRequest } from "../../common/features/auth/AuthActions";
import { ReactComponent as CancelIcon } from "../../common/assets/svg/cancelIconnew.svg";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ACCESS_TOKEN, USER_DETAILS, USER_ID, SESSION_ERROR_SHOWN } from "../../common/constants";
import { storeSelectedIngredientChecklist, storeToggleStatus } from "../../common/features/restaurant/restaurantAction";
import { getCookie, setCookie, deleteCookie } from "../../helper/cookieHelper";
import { setSignupPopup } from "../../common/features/navigation/navigationActions";
import { removeauthInfo } from "../../common/features/auth/AuthActions";
import { Store } from "../../common/configureStore";
import { showErrorToast, showErrorToastDesktop } from "../../common/utils/toastUtils";
import { resetSessionErrorFlag } from "../../common/Api";

// const AUTO_OTP_LENGTH = 4;
const OtpScreenNew = ({ onClose, setCurrentPage, userData, isMobile, signInPopupDesktop, countryData, data, handleVerifySubmit }: any) => {
  const dispatch = useDispatch()
  // const userCountry = useSelector((state: any) => state.auth?.countryCode);
  const verifyOtpSuccess = useSelector((state: any) => state.auth.verifyOtpSuccess);
  const verifyOtpMessage = useSelector((state: any) => state.auth.verifyOtpMessage);
  const verifyOtpLoading = useSelector((state: any) => state.auth.verifyOtpLoading);
  const verifyOtpFailure = useSelector(
    (state: any) => state.auth.verifyOtpFailure
  );

  const otpExceed = useSelector(
    (state: any) => state.auth.getOtpMessage
  );

  const OTP_LENGTH = 6;

  const { merchantType, merchantSlug } = useParams()
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const [otp, setOtp] = useState<string[]>(new Array(OTP_LENGTH).fill(""));
  const [timer, setTimer] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleOtpComplete = (otp: string) => {
  };

  useEffect(() => {
    if ('OTPCredential' in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: ac.signal,
        } as any)
        .then((otp) => {
          if (otp) {
            setOtp(otp.toString().split(""));
          }
          ac.abort();
        })
        .catch((err) => {
          ac.abort();
          console.error(err);
        });
    }
  }, []);


  const startTimer = () => {
    setTimer(180);
    // setIsResendDisabled(true);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current as NodeJS.Timeout);
          setIsResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current as NodeJS.Timeout);
  }, []);

  if (inputRefs.current.length !== OTP_LENGTH) {
    inputRefs.current = Array(OTP_LENGTH).fill(null);
  }

  const handleChange = (index: number, value: string) => {
    // Handle paste - if value length > 1, it's likely a paste operation
    if (value.length > 1) {
      const numericValue = value.replace(/\D/g, '').slice(0, OTP_LENGTH);
      const newOtp = [...otp];
      
      numericValue.split('').forEach((char, i) => {
        if (index + i < OTP_LENGTH) {
          newOtp[index + i] = char;
        }
      });
      
      setOtp(newOtp);
      
      // Focus the next empty input or the last filled input
      const nextIndex = Math.min(index + numericValue.length, OTP_LENGTH - 1);
      setTimeout(() => {
        inputRefs.current[nextIndex]?.focus();
      }, 0);
      
      const otpValue = newOtp.join("");
      if (otpValue.length === OTP_LENGTH && handleOtpComplete) {
        handleOtpComplete(otpValue);
      }
      return;
    }

    // Handle single character input
    if (isNaN(Number(value))) return;
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    // Move to next input if value is entered
    if (value && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    // Check if OTP is complete
    const otpValue = newOtp.join("");
    if (otpValue.length === OTP_LENGTH && handleOtpComplete) {
      handleOtpComplete(otpValue);
    }
  };

  const handleKeyDown = (index: number, e: any) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      // Move to previous input on backspace if current input is empty
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const clipboardData = e.clipboardData || (window as any)?.clipboardData;
    const pastedData = clipboardData
      ?.getData("text")
      ?.trim()
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);

    if (!pastedData || pastedData.length === 0) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const newOtp = [...otp];
    pastedData.split("").forEach((value: string, index: number) => {
      if (index < OTP_LENGTH) {
        newOtp[index] = value;
      }
    });

    setOtp(newOtp);
    
    // Focus the next empty input or the last filled input
    const nextIndex = Math.min(pastedData.length, OTP_LENGTH - 1);
    setTimeout(() => {
      inputRefs.current[nextIndex]?.focus();
    }, 0);
  };

const handleverifyOtp = (e: React.FormEvent) => {
  e.preventDefault();

  const mobileOtpDetails = {
    mobilePhone: userData.mobilePhone || '',
    otp: otp.join(''),
    sendOtpViaEmail : restaurantDetails?.platformConfiguration?.sendOtpViaEmail
  } as any;

  const emailOtpDetails = {
    email: userData?.email || '',
    otp: otp.join(''),
    sendOtpViaEmail : restaurantDetails?.platformConfiguration?.sendOtpViaEmail
  } as any;

  const userDetails = getCookie(USER_DETAILS) || {};

  if (userData.mobilePhone) {
    userDetails.mobilePhone = userData.mobilePhone;
    setCookie(USER_DETAILS, userDetails);
  }

  dispatch(verifyOtpRequest(restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? emailOtpDetails : mobileOtpDetails));

  handleVerifySubmit();
};

  const handleSubmit = (e: React.ChangeEvent<HTMLInputElement>) => {
    const opt = e.target.value?.split("");
    setOtp(otp);
    if (otp.join("").length === OTP_LENGTH && !verifyOtpLoading) {
      handleverifyOtp(e);
    }
  }
  useEffect(() => {
    if (verifyOtpSuccess) {
      // Reset session error flag on successful login
      resetSessionErrorFlag();
      
      // Clear global menu filters/toggles only after successful OTP verification
      try {
        dispatch(
          storeToggleStatus({ onlyAvailable: false, nonVegetarian: false, vegetarian: false })
        );
        dispatch(storeSelectedIngredientChecklist([]));
      } catch {}

      if (verifyOtpMessage?.body?.customerDetails?.customerId) {
        setCookie(USER_ID, verifyOtpMessage?.body?.customerDetails?.customerId);
        // localStorage.setItem(USER_DETAILS, JSON.stringify(verifyOtpMessage?.body?.customerDetails))
        // localStorage.setItem(USER_ID, verifyOtpMessage?.body?.customerDetails?.customerId)
        setCookie(USER_DETAILS, verifyOtpMessage?.body?.customerDetails);
        onClose();
      } else {
        setCurrentPage("EditProfile")
      }
    }
  }, [verifyOtpSuccess, verifyOtpMessage])

  const handleResendOtp = () => {
    setTimer(16);
    setIsResendDisabled(true);

    dispatch(getOtpRequest(!restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? {
      mobilePhone: countryData?.code + "-" + (data?.inputData || userData?.mobilePhone || ""),
      sendOtpViaEmail: false
    } : {
      email: userData?.email || "",
      sendOtpViaEmail: true
    }));

    startTimer();
  };

  useEffect(() => {
    if (timer === 0) {
      setIsResendDisabled(false);
    } else {
      setIsResendDisabled(true);
    }
  }, [timer]);

  return (
    <>
      {
        isMobile && <button className={"close-btnZa-otpScreen close-mobile-view"} onClick={() => onClose(true)}>
          {/* <img src={cancelIcon} alt="" /> */}
          <CancelIcon
            className="signInCancel-btn"
            onClick={() => onClose()}
          />
        </button>
      }


      <div className={isMobile ? "otp-container" : signInPopupDesktop ? "otp-container-D" : "otp-container-D-checkout"}>
        <div className={isMobile ? "otp-card" : "otp-card-D"}>
          {
            (isMobile || signInPopupDesktop) && <h1 className="otp-title">Enter OTP</h1>
          }


          <div className={isMobile ? "otp-subtitle" : signInPopupDesktop ? "otp-subtitle-D-popup" : "otp-subtitle-D"} >
            <span className={isMobile ? "otp-subtitle-text" : signInPopupDesktop ? "otp-subtitle-text-D-popup" : "otp-subtitle-text-D"}>
              We send a one-time password to this {restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? "email id" : "mobile number"}
            </span>
            < div className="mobile-view">
              <span
                className={isMobile ? "otp-subtitle-text-phoneNumber" : "otp-subtitle-text-phoneNumber-D"}
                style={{ color: "#E31837" }}
              >
                {data?.inputData}
              </span>
              <span
                className={isMobile ? "otp-subtitle-text-change" : "otp-subtitle-text-change-D"}
                onClick={() => {
                  setCurrentPage("signin")
                }}
              >
                Change
              </span>
            </div>


            <p className="otp-desktop-numberChange-D desktop-view">
              <span
                className={isMobile ? "otp-subtitle-text-phoneNumber" : "otp-subtitle-text-phoneNumber-D"}
                style={{ color: "#E31837" }}
              >
                {data?.inputData}
              </span>
              <span
                className={isMobile ? "otp-subtitle-text-change" : "otp-subtitle-text-change-D"}
                onClick={() => {
                  setCurrentPage("signin")
                }}
              >
                Change
              </span>
            </p>

          </div>

          <form>
            <div className={isMobile ? "form-group-otp" : signInPopupDesktop ? "form-group-otp-D-popup" : "form-group-otp"}>

              {/* Hidden single input targeted by mobile OS autofill. Important: keep in DOM, don't use display:none. Using opacity:0 and small size
                makes it visible to autofill while not intrusive. */}

              <input type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                pattern={`\\d{${OTP_LENGTH}}`}
                maxLength={OTP_LENGTH}
                onChange={handleSubmit}
                style={{ position: "absolute", left: 0, top: 0, width: "1px", height: "1px", padding: 0, border: 0, margin: 0, opacity: 0, zIndex: -1, }}
                aria-hidden="true"
                value={otp?.join("")} />

              {otp.map((value, index) => (
                <input
                  key={index}
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={index === 0 ? OTP_LENGTH : 1}
                  value={value}
                  ref={(ref) => {
                    inputRefs.current[index] = ref;
                  }}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  className="otp-input"
                  autoComplete="off"
                />
              ))}
            </div>
            <div>
              {verifyOtpFailure && <div className="error-message otp-error">Please enter valid otp</div>}
            </div>
            {
              !(otpExceed?.httpStatus === 429) &&
              <div
                className="Resend-container-otp"
                style={{ cursor: isResendDisabled ? "not-allowed" : "pointer" }}
              >
                <button
                  onClick={handleResendOtp}
                  type="button"
                  disabled={isResendDisabled}
                >
                  <span
                    className={!isResendDisabled ? "Resendotp-text cursror" : ""}
                  >Resend OTP </span>
                  <span
                    style={{ color: 'black' }}
                  >
                    {timer > 0 && "in"}
                  </span>
                  <span
                    style={{
                      color: "#E31837",
                      marginLeft: "5px",
                      fontWeight: "600",
                      fontFamily: "Outfit",
                    }}
                  >
                    {timer > 0
                      ? ` ${String(Math.floor(timer / 60)).padStart(2, '0')}:${String(timer % 60).padStart(2, '0')}`
                      : ""}
                  </span>
                </button>
              </div>
            }

            <div className="otp-button-container">

              <button
                type="submit"
                disabled={verifyOtpLoading || otp?.some((item) => item === "") || otpExceed?.httpStatus === 429}
                className={`${isMobile ? "otp-button" : signInPopupDesktop ? "otp-button-Desktop-D-popup" : "otp-button-Desktop"} ${(otp?.every((item) => item !== "") && !(otpExceed?.httpStatus === 429)) ? "" : "disabled"}`}
                // className={isMobile ? "otp-button" : 
                //   otp.some((digit) => digit === "") ? "otp-button-Desktop-D-popup-disable" : 
                //   signInPopupDesktop ? "otp-button-Desktop-D-popup" : 
                //   "otp-button-Desktop"
                // }
                onClick={handleverifyOtp}
              >
                {verifyOtpLoading ? 'Loading...' : 'Sign In'}
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  );
};

export default OtpScreenNew;